<template>
    <hr/>
</template>

<script>
export default {
  name: 'Separator',
  props: {

  }
}
</script>

<style scoped lang="scss">

</style>
